import moment from 'moment';
import { getPageFeatureLevel } from './tag-service';

export function sortPagesByFeatured(a, b) {
    let ret = 0;

    ret = getPageFeatureLevel(b) - getPageFeatureLevel(a);
    if (ret === 0) {
        let titleA = a.title.toLowerCase();
        let titleB = b.title.toLowerCase();

        ret = titleA.localeCompare(titleB);
    }

    return ret;
}

export function sortPagesByName(a, b) {
    let titleA = a.title.toLowerCase();
    let titleB = b.title.toLowerCase();

    return titleA.localeCompare(titleB);
}

export function sortPagesByDate(a, b) {
    return moment(b.date).unix() - moment(a.date).unix();
}
